export default {
  title: 'Provisión de fondos',
  fundProvision: 'Provisión de fondos'
}
